import { createPromiseAction } from 'redux-saga-promise-actions';
import { CheckoutPayload, CheckoutResponse, GetBpeInfoPayload } from 'store/types/checkout';
import { createAction } from 'typesafe-actions';

export const makePaymentBR = createPromiseAction('MAKE_PAYMENT', 'MAKE_PAYMENT_SUCCESS', 'MAKE_PAYMENT_FAILURE')<
  CheckoutPayload,
  CheckoutResponse,
  undefined
>();
export const getInfoBpe = createPromiseAction('INFO_BPE', 'INFO_BPE_SUCCESS', 'INFO_BPE_FAILURE')<
  GetBpeInfoPayload,
  {},
  undefined
>();
export const createPaymentLink = createPromiseAction(
  'CREATE_PAYMENT_LINK',
  'CREATE_PAYMENT_LINK_SUCCESS',
  'CREATE_PAYMENT_LINK_FAILURE',
)<CheckoutPayload, CheckoutResponse, undefined>();

export const handleModal402 = createAction('HANDLE_MODAL_402', (isActive: boolean) => ({
  isActive,
}))<{ isActive: boolean }>();

export const handleScreen412 = createAction('HANDLE_SCREEN_412', (is412: boolean) => ({
  is412,
}))<{ is412: boolean }>();
